import { useFormikContext } from 'formik';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../../../../../components/Input/Input';
import { useAppSelector } from '../../../../../../reduxService/hooks';
import { EConversionSIToImperial, conversionLabel, convertTo } from '../../../../../conversion';
import { roundToFour, roundToTwo } from '../../Geometry/utils';
import { IFormikForm } from '../ModalMaterial/FormikMaterial';
import { selectProjectInfo } from '../../../../../store/projectInfo/projectInfoSlice';
import { CheckForAllMats } from '../MaterialDataCheckboxes/CheckForAllMats';
import { UnitOfMeasure } from '../../../../../enum/project';

interface INaturalProps {
    hideForALl?: boolean;
}

const Natural = (props: INaturalProps) => {
    const projectInfo = useAppSelector(selectProjectInfo);
    const { t } = useTranslation();
    const { values, setFieldValue } = useFormikContext<IFormikForm>();
    let isImperial = projectInfo?.data?.unitOfMeasure == UnitOfMeasure.Imperial;
    
    const handleRoughnessChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue(`${values.sectorChannel}.roughness`, roundToFour(parseFloat(e.target.value)));
    };

    return (
        <>
            {!props.hideForALl && <CheckForAllMats />}
            <div className='d-flex justify-content-between mt-2 gap-2'>
                <Input
                    title={t('material_shear_stress', { unit_measure: conversionLabel.Nm2_lbfft2[projectInfo.data?.unitOfMeasure as number] })}
                    type='number'
                    name={`${values.sectorChannel}.allowShearStress`}
                    value={roundToTwo(
                        isImperial ? convertTo(values[values.sectorChannel].allowShearStress!, EConversionSIToImperial.Nm2_to_lbfft2) : values[values.sectorChannel].allowShearStress ?? 0,
                    )}
                    disabled
                />
                <Input
                    title={t('material_roughness')}
                    type='number'
                    name={`${values.sectorChannel}.roughness`}
                    value={values[values.sectorChannel].roughness}
                    onChange={e => handleRoughnessChange(e)}
                />
            </div>
        </>
    );
};

export default Natural;
